module.exports = require('../Sphere').SphereFunction;